import * as actionTypes from "./actionTypes";
import * as actions from "./index";
import { isNLW } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

export const getDistributionsStart = () => {
  return {
    type: actionTypes.GET_DISTRIBUTIONS_START
  };
};

export const getDistributionsSuccess = distributions => {
  return {
    type: actionTypes.GET_DISTRIBUTIONS_SUCCESS,
    distributions: distributions
  };
};

export const getDistributionsFail = error => {
  (error === "Instagram" || error === 145) &&
    alert("Distribution for " + error + " is not set.");
  return {
    type: actionTypes.GET_DISTRIBUTIONS_FAIL,
    error: error
  };
};

export const setCurrentDistribution = id => {
  return {
    type: actionTypes.SET_CURRENT_DISTRIBUTION,
    currentDistribution: id
  };
};

export const setActiveDistribution = id => {
  return {
    type: actionTypes.SET_ACTIVE_DISTRIBUTION,
    payload: { activeDistribution: id }
  };
};

export const getTweetsSuccess = tweets => {
  return {
    type: actionTypes.TWITTER_GET_TWEETS_SUCCESS,
    tweets: tweets
  };
};

export const twitterNewTweet = () => {
  console.log("New Tweet");
  return dispatch => {
    window.flow
      .twitterNewTweet()
      .then(response => {
        console.log(response);
      })
      .catch(response => {
        console.log(response);
      });
  };
};
export const publisher = (distributionId, clipId, parameters) => {
  console.log(distributionId);
  if (distributionId === 144) {
    return dispatch => {
      window.flow
        .newProcess("batch", "NewsTV via Flow2", {
          clipid: clipId,
          parameters: { batch: 7 }
        })
        .then(response => {
          console.log(response);
        })
        .catch(response => {
          console.log(response);
          dispatch(getDistributionsFail(response));
        });
    };
  }

  if (distributionId === "Twitter") {
    return dispatch => {
      window.flow
        .twitterNewTweet(clipId)
        .then(response => {
          console.log(response);
        })
        .catch(response => {
          console.log(response);
          dispatch(getDistributionsFail(response));
        });
    };
  }

  if (distributionId === "Instagram") {
    return dispatch => {
      dispatch(getDistributionsFail(distributionId));
    };
  }

  if (distributionId === 145) {
    return dispatch => {
      dispatch(getDistributionsFail(distributionId));
    };
  }
};

export const getDistributions = distributionId => {
  console.log('getDistributions');
  console.log(distributionId);
  return dispatch => {
    dispatch(getDistributionsStart());

    window.flow
      .twitterGetTweets()
      .then(response => {
        console.log('getDistributions::success');
        console.log(response);
        dispatch(getDistributionsSuccess(response));
      })
      .catch(response => {
        console.log(response);
      });

    //just dummy
    /*const delay = t => new Promise(resolve => setTimeout(resolve, t));
        
        delay(4000).then(() => {
                let dummy = [{
                    distributionId: 123,
                    title: '1. Distribution'
                }, 
                {
                    distributionId: 143,
                    title: '2. Distribution'
                }, 
                {
                    distributionId: 12,
                    title: '3. Distribution'
                }, 
                ]    
                dispatch(getDistributionsSuccess(dummy));
            
        }).catch(res => {
  
            dispatch(getDistributionsFail(res.msg));
        });      */
  };
};

export const getTweets = () => {
  return dispatch => {
    window.flow
      .twitterGetTweets()
      .then(response => {
        console.log(response);
        dispatch(getTweetsSuccess(response));
      })
      .catch(response => {
        console.log(response);
      });
  };
};

export const updateCDN = () => {
  let profile = 'porscheupload_sync';
  let ps_name = 'Porsche CDN Sync';
  if (isNLW()) {
    profile = 'nlwpublicfrontend';
    ps_name = 'NLW CDN Sync';
  }
  return dispatch => {
    window.flow.newProcess('customprocess', ps_name, {
      parameters: { profile: profile, makepackage: 1, all: 1 }
    }).then(res => {
      console.log(res);
    }).catch(res => {
      console.error(res);
    });
  };
}

export const exportToCarreraTv = (id, user) => {
  return dispatch => {
    window.flow.newProcess('customprocess', 'Export carreraTV: Flow2, User ' + user.id + ' via button (Detailview/DistributionTab/carreraTV)', {
      clipid: id,
      parameters: { profile: 'export_carreratv' }
    }).then(response => {
      if (response.success) {
        // interval to check process state
        let interval = setInterval(function () {
          window.flow.getProcess(response.processid).then(p => {
            console.log(p.getStatus());
            if (p.getStatus() == 'done') {
              clearInterval(interval);
              dispatch(actions.getClipById(id));
            } else if (p.getStatus() == 'error') {
              clearInterval(interval);
              console.error(response);
            }
          })
        }, 2000);
      } else {
        console.error(response);
      }
    }).catch(response => {
      console.error(response);
    });
  };
}
